import React, { useContext } from 'react'

import context from '../core/context'

import FilterStep from './filter-step'
import DeveloperStep from './developer-step'
import QuoteStep from './quote-step'
import CalendlyStep from './calendly-step'

function StepView(props) {
  const { step } = useContext(context)

  switch (step) {
    case 0:
      return <FilterStep {...props} />
    case 1:
      return <DeveloperStep {...props} />
    case 2:
      return <QuoteStep {...props} />
    case 3:
      return <CalendlyStep {...props} />
    default:
      return null
  }
}

export default StepView
